import React from "react";
import { createRoot } from "react-dom/client";  // Updated import
import Modal from "react-modal";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import store from "./store";
import { initializeAuthSession } from "./helpers/repository";

initializeAuthSession();

// Silences react-modal's "App element is not defined" warning app-wide
// (screen readers hide #root's content while any Modal is open).
Modal.setAppElement("#root");

const root = createRoot(document.getElementById("root"));  // Create root

root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </I18nextProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals